import { AfterContentInit, Component, ContentChildren, QueryList } from '@angular/core';
import { Observable } from 'rxjs';
import { delay, map, startWith } from 'rxjs/operators';
import { Comparator, SortEvent } from './../admin-table/models/admin-table.model';
import { AdminTableColumnComponent } from './admin-table-column/admin-table-column.component';
import { AdminTableColumnService } from './admin-table-column/admin-table-column.service';
import { AdminTableRowComponent } from './admin-table-row/admin-table-row.component';

@Component({
  selector: 'mpro-atable',
  templateUrl: './admin-table.component.html',
  styleUrls: ['./admin-table.component.scss'],
  providers: [AdminTableColumnService]
})
export class AdminTableComponent implements AfterContentInit {
  @ContentChildren(AdminTableColumnComponent)
  public cols: QueryList<AdminTableColumnComponent>;
  public colItems$: Observable<AdminTableColumnComponent[]>;

  @ContentChildren(AdminTableRowComponent)
  public rows: QueryList<AdminTableRowComponent>;
  public rowItems$: Observable<AdminTableRowComponent[]>;

  public static sort<T>(collection: T[], sortEvent: SortEvent): T[] {
    const copy = collection.slice();
    const compare: Comparator = sortEvent.comparator ? sortEvent.comparator() : (a: any, b: any, column: string) => {
      if (typeof a[column] === 'string' && typeof b[column] === 'string') {
        return a[column].localeCompare(b[column]);
      }

      return (a[column] < b[column] || !b[column]) ? -1 : a[column] > b[column] ? 1 : 0
    };

    return copy.sort((a, b) => compare(sortEvent.direction === 'desc' ? b : a, sortEvent.direction === 'desc' ? a : b, sortEvent.column));
  }

  public ngAfterContentInit(): void {
    this.colItems$ = this.cols.changes
      .pipe(startWith(''))
      .pipe(delay(0))
      .pipe(map(() => {
        if (!this.hasDefaultSortColumn()) {
          this.cols.first.defaultSortable = true;
        }

        return this.cols.toArray();
      }));

    this.rowItems$ = this.rows.changes
      .pipe(startWith(''))
      .pipe(delay(0))
      .pipe(map(() => this.rows.toArray()));
  }

  private hasDefaultSortColumn(): boolean {
    return this.cols.some(col => col.defaultSortable);
  }
}